// public/js/utils/person-name.js
// Display a user as first + last name only. Accepts an email or a full name.
//   - email → take the local part before '@'
//   - split on common separators ( . _ - + and whitespace )
//   - one token → that token; two or more → FIRST + LAST (middles dropped)
//   - each shown token is capitalised
// Examples: "jan.schaer@thingware.ch" → "Jan Schaer" · "frank@x.com" → "Frank"
//           "vorname.mittel.nachname" → "Vorname Nachname" · "Jan Schaer" → "Jan Schaer"
export function formatPersonName(raw) {
  if (!raw) return '';
  let s = String(raw).trim();
  const at = s.indexOf('@');
  if (at > 0) s = s.slice(0, at);                 // email → local part
  const parts = s.split(/[._+\-\s]+/).filter(Boolean);
  if (!parts.length) return s;
  const pick = parts.length >= 2 ? [parts[0], parts[parts.length - 1]] : [parts[0]];
  const cap = (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
  return pick.map(cap).join(' ');
}
